import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';

import CurrentStatus from 'components/atoms/CurrentStatus';
import Section from 'components/molecules/Modal/Section';
import Header from 'components/molecules/Modal/Header';
import Footer from 'components/molecules/Modal/Footer';

const useStyles = makeStyles((theme) => ({
  modal: {
    zIndex: theme.zIndex.modal + ' !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    color: '#4d4f5c',
    maxHeight: '95%',
    overflowY: 'auto',
    outline: 'none',
  },
  formTable: {
    marginBottom: 15,
    width: '100%',
    borderCollapse: 'collapse',
    '& > tbody > tr': {
      '& > th, & > td ': { borderBottom: '1px solid #c4c4c4' },
      '& > td': { padding: 12 },
    },
    '& .formTextField': {
      width: 250,
      maxWidth: 250,
      '& input': { padding: '8px 14px' },
      '& p': { marginLeft: 0 },
    },
  },
  loading: {
    zIndex: '100000',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgb(255 255 255 / 0.6)',
  },
}));

/**
 * 기본 레이아웃 모달 불러오기
 */
const ModalBasic = ({
  children,
  useForm = false,
  open = false,
  headerOpen = true,
  headerTitle = '',
  closeBtn = true,
  confirmBtnOpen = true,
  confirmBtnTitle = '확인',
  confirmOnClick = (f) => f,
  cancelBtnOpen = true,
  cancelBtnTitle = '취소',
  toolTip,
  width = 'auto',
  height = 'auto',
  style = {},
  handleClose = (f) => f,
  loading = false,
}) => {
  const classes = useStyles();
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onEscapeKeyDown={handleClose}
      >
        <Fade in={open}>
          <div
            className={classes.paper}
            style={{ width: width, height: height, ...style }}
          >
            {loading && (
              <div className={classes.loading}>
                <CurrentStatus type="loading" />
              </div>
            )}
            <Header
              headerOpen={headerOpen}
              headerTitle={headerTitle}
              closeBtn={closeBtn}
              closeOnClick={handleClose}
              toolTip={toolTip}
            />
            <Section>
              {useForm ? (
                <>
                  <table className={classes.formTable}>
                    <tbody>{children}</tbody>
                  </table>
                </>
              ) : (
                children
              )}
            </Section>
            <Footer
              confirmOnClick={confirmOnClick}
              cancelOnClick={handleClose}
              confirmBtnOpen={confirmBtnOpen}
              confirmBtnTitle={confirmBtnTitle}
              cancelBtnOpen={cancelBtnOpen}
              cancelBtnTitle={cancelBtnTitle}
            />
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default ModalBasic;
